export default "__VITE_ASSET__BLrJ_Pjz__"